<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header" style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
      border-left: none;
    ">
    <mat-card-title class="mcd-card-title">Upcoming Standards</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row">
      <div class="col filter-panel">
        <app-filter-tags [isNrbes]="false" (messageEvent)="receivedFilteration($event)"
          (searchApplied)="onSearchFromChild($event)" [searchKeyFromParent]="searchKey"
          (exportFiltersApplied)="onExportFiltersApplied($event)"></app-filter-tags>
      </div>
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>

    <div class="table-wrapper" *ngIf="grses.length > 0">
      <div class="row">
        <!-- <div class="col-6">
          <mat-form-field>
            <mat-select
              [value]="pageSize"
              name="nOfRows"
              #items
              (selectionChange)="selectedItemsPerPageChange(items)"
            >
              <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
      </div>
      <table class="table nrbes-grid" matSort (matSortChange)="sortData($event)">
        <thead class="thead-light">
          <tr>
            <th mat-sort-header="title" width="22%" scope="col">
              <div class="title-cell-wrapper">
                <mat-checkbox *ngIf="getSelectableRowsOnPage().length > 0" color="primary"
                  [checked]="isAllOnPageSelected()" [indeterminate]="isSomeOnPageSelected()"
                  (click)="$event.stopPropagation()" (change)="selectAllOnPageChange($event)"></mat-checkbox>
                <span>Standard Title</span>
              </div>
            </th>
            <th width="6%">Type</th>

            <th width="30%">Location</th>
            <!-- <th mat-sort-header="desc" scope="col-4" width="30%">
              Description
            </th> -->
            <th mat-sort-header="category" scope="col" width="16%">Category</th>
            <!-- <th scope="col" width="20%">Existing Restaurant Effective From</th> -->
            <th scope="col" width="13%">Effective From</th>

            <!-- <th scope="col-2" width="140" *ngIf="userRole == 1">Exception</th> -->
            <th scope="col-2" width="8%" *ngIf="userRole == 1" style="text-align: center">
              Exceptions
            </th>
            <th scope="col" width="5%" *ngIf="isGlobalAdmin()"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of grses" (click)="rowSelected(item)">
            <td class="title-cell" style="font-weight: 500; color: #3949a3; font-size: 14px; padding: 12px;">
              <div class="title-cell-wrapper">
                <mat-checkbox color="primary" [checked]="isSelected(item.id)" (click)="$event.stopPropagation()"
                  (change)="onCheckboxChange($event, item.id)"></mat-checkbox>
                <span class="standard-title-text">{{ item.title }}</span>
              </div>
            </td>
            <td class="hide-sm">
              <img [src]="getStandardIcon(item.standardTypeId)" height="16" width="16" />
            </td>

            <td class="location-cell">{{ getLocationNames(item) }}</td>
            <!-- <td class="description">
              <span title="{{ item.shortDescription }}" class="description">
                {{ item.description }}
              </span>
            </td> -->
            <td class="category-cell">{{ item.category.name }}</td>
            <!-- <td *ngIf="item.effectiveFrom" class="hide-sm">
              {{ item.effectiveFrom | date : "MM.dd.yyyy" }}
            </td> -->
            <td *ngIf="!item.effectiveFrom" class="hide-sm">N/A</td>
            <td *ngIf="item.newRestaurantsEffectiveFrom" class="hide-sm">
              {{ item.newRestaurantsEffectiveFrom | date: "MM.dd.yyyy" }}
            </td>
            <td *ngIf="!item.newRestaurantsEffectiveFrom" class="hide-sm">
              N/A
            </td>

            <!-- <td *ngIf="userRole == 1">
              <a
                href="javascript:void(0);"
                *ngIf="!item.availabileAddendumId && userRole != 3"
                (click)="addAddendum(item.id, $event)"
                >Add Exception</a
              > -->
            <!-- <a
                href="javascript:void(0);"
                (click)="addendumService.isCommingFromNrbes = true"
                *ngIf="item.availabileAddendumId && userRole != 3"
                (click)="goToAddendum(item)"
                >Go to Exception</a
              >
              <a
                href="javascript:void(0);"
                (click)="addendumService.isCommingFromNrbes = true"
                *ngIf="
                  item.availabileAddendumId &&
                  userRole == 3 &&
                  item.addendumStatusId == addendumStatusEnum.Approved
                "
                (click)="goToAddendum(item)"
                >Go to Exception</a
              > -->
            <!-- </td> -->

            <td style="text-align: center" *ngIf="userRole == 1">
              {{ item.addendum.length }}
            </td>

            <td *ngIf="isGlobalAdmin()">
              <div class="grid-actions hide-sm" *ngIf="selectedRowsForExport.length < 2">
                <button style="border: none; background: none" (click)="togglePopup($event, item)">
                  <img src="/assets/images/menu-dots 2.svg" />
                </button>

                <div class="action-popup editDeletModal" *ngIf="activePopupId === item.id">
                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="onEditHover"
                    (click)="onEdit(item)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: rgba(63, 81, 181, 1);
                        font-size: 14px;
                        text-align: left;
                        display: block;
                        width: 100%;
                      " routerLinkActive="active" title="Edit" href="javascript:void(0);">
                      <span><img src="/assets/images/d-edit 1.svg"
                          style="margin-bottom: 4px; margin-right: 5px" /></span>
                      <span>Edit</span>
                    </a>
                  </div>

                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="onEditHover"
                    *ngIf="!item.availabileAddendumId && userRole != 3" (click)="addAddendum(item.id, $event)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: #3f51b5;
                        font-size: 14px;
                        display: block;
                        width: 100%;
                      " routerLinkActive="active" title="Add">
                      <span><img src="/assets/images/file-new 1.svg"
                          style="margin-bottom: 4px; margin-right: 5px" /></span>

                      <span>Add Exception</span>
                    </a>
                  </div>
                  <hr style="margin: 2px; border: 1px solid #dde1e6" />

                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="oDeleteHover"
                    (click)="openDeleteModal(item, $event)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: rgba(222, 52, 40, 1);
                        font-size: 14px;
                        display: block;
                        width: 100%;
                      " routerLinkActive="active" title="clear">
                      <span><img src="/assets/images/bin.svg" style="margin-bottom: 4px; margin-right: 5px" /></span>

                      <span>Delete</span>
                    </a>
                  </div>
                </div>
              </div>
              <!-- <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="openDeleteModal(item, $event)"
                    routerLinkActive="active"
                    title="clear"
                    ><i class="material-icons"> clear </i></a
                  >
                </div>
                <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="onEdit(item.id)"
                    routerLinkActive="active"
                    title="Edit"
                    href="javascript:void(0);"
                    ><i class="material-icons"> create </i></a
                  >
                </div>

              <a
                (click)="actionMenuOpen($event)"
                class="mcd-more-btn show-sm"
                [matMenuTriggerFor]="menu"
                href="javascript:void(0);"
              >
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button mat-menu-item (click)="onEdit(item.id)">Edit</button>
                  <button
                    mat-menu-item
                    (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                  >
                    Remove
                  </button>
                </span>
              </mat-menu> -->
            </td>
            <!-- <td *ngIf="userRole == 1">
              <div class="row grid-actions hide-sm">
                <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="openDeleteModal(item, $event)"
                    routerLinkActive="active"
                    title="clear"
                    ><i class="material-icons"> clear </i></a
                  >
                </div>
                <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="onEdit(item)"
                    routerLinkActive="active"
                    title="Edit"
                    href="javascript:void(0);"
                    ><i class="material-icons"> create </i></a
                  >
                </div>
              </div>

              <a
                (click)="actionMenuOpen($event)"
                class="mcd-more-btn show-sm"
                [matMenuTriggerFor]="menu"
                href="javascript:void(0);"
              >
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button
                    mat-menu-item
                    *ngIf="canEditEquipmentStandard"
                    (click)="onEdit(item)"
                  >
                    Edit
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="canDeleteEquipmentStandard"
                    (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                  >
                    Remove
                  </button>
                </span>
              </mat-menu>
            </td> -->
          </tr>
        </tbody>
      </table>

      <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        " *ngIf="grses.length > 0">
        <div>
          <div>
            <mat-form-field>
              <mat-select style="
                  padding: 8px 16px;
                  border: 1px solid #dde1e6;
                  border-radius: 4px;
                  background-color: #f8fafb;
                  color: #4d5258;
                  font-weight: 500;
                " [value]="pageSize" name="nOfRows" #items (selectionChange)="selectedItemsPerPageChange(items)">
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- <div class="col-6 float-right">
          
          <a
            *ngIf="grses.length > 0 && isDownloading"
            class="float-right"
            disabled
            style="color: #0b59ca; text-decoration: none; cursor: pointer"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-bottom: 2px; margin-right: 2px"
            >
              <path
                d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Downloading, Please wait...
          </a>
          <a
            *ngIf="grses.length > 0 && !isDownloading"
            class="float-right"
            href="javascript:void(0);"
            (click)="downloadExcel()"
            style="
              margin-top: 10px;
              color: #0b59ca;
              text-decoration: none;
              cursor: pointer;
            "
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-bottom: 2px; margin-right: 2px"
            >
              <path
                d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Download
          </a>
        
        </div> -->

        <div>
          <div>
            <ngb-pagination class="float-right" [(page)]="page" [pageSize]="pageSize" [maxSize]="4" [rotate]="true"
              [ellipses]="true" [collectionSize]="collectionSize" (pageChange)="getStandards()"></ngb-pagination>
          </div>
        </div>

        <div style="display: flex; gap: 10px">
          <button class="prevButton" [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f',
            }" (click)="goToPreviousPage()">
            <img src="/assets/images/leftarrow.svg" />

            Previous
          </button>
          <button class="nextButton" [ngStyle]="{
              border:
                page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f',
            }" (click)="goToNextPage()">
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="grses.length == 0 && !searchKey" class="noResults">
      Sorry you do not have any standard.
    </div>

    <div *ngIf="grses.length == 0 && searchKey" class="search-empty-state">
      <img
        src="/assets/images/GRBES-List.svg"
        alt=""
        class="search-empty-icon"
      />
      <h4 class="search-empty-title">No results found</h4>
      <p class="search-empty-subtitle">
        Try a different keyword or refine your search to find what you're
        looking for.
      </p>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>